import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, lifecycle, withState, branch, renderNothing } from 'recompose';

import { checkDeepLinks } from 'modules/auth/actions/checkEntryDeepLinks';

import PrivatePageContainer from './PrivatePageContainer';

const propTypes = {
  component: PropTypes.func.isRequired,
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    { ...rest }
    render={ (props) => (
      <PrivatePageContainer>
        <Component { ...props } />
      </PrivatePageContainer>
    ) }
  />
);

PrivateRoute.propTypes = propTypes;

export default compose(
  connect(null, { checkDeepLinks }),
  withState('redirectChecked', 'setRedirectChecked', false),
  lifecycle({
    componentDidMount() {
      this.props.checkDeepLinks(this.props.setRedirectChecked);
    },
  }),
  branch(({ redirectChecked }) => !redirectChecked, renderNothing),
)(PrivateRoute);
